import { render } from "./docFilters.vue?vue&type=template&id=4c3c0907"
import script from "./docFilters.vue?vue&type=script&lang=js"
export * from "./docFilters.vue?vue&type=script&lang=js"

import "./docFilters.vue?vue&type=style&index=0&id=4c3c0907&lang=scss"

import exportComponent from "/home/ivan/Downloads/3(1)/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__